module.exports = __webpack_public_path__ + "img/yhtx.6db06579.png";